$(document).ready(function() {
  let formStarted = [];

  // helper functions
  function anchorHref(target, defaultValue) {
    const anchor = target.tagName === 'A' ? target : target.closest('a');
    const href = anchor ? anchor.href : '';
    return href.trim() || defaultValue;
  }
  function anchorText(target) {
    const anchor = target.tagName === 'A' ? target : target.closest('a');
    return anchor ? elementText(anchor) : '';
  }
  function elementText(target, showHiddenText = false) {
    if (showHiddenText) {
      return target.textContent.replace(/\s+/g, ' ').trim();
    }
    return target.innerText.replace(/\s+/g, ' ').trim();
  }
  function videoName(target) {
    let videoUrl = target.src;
    if (!videoUrl) {
      const source = target.querySelector('source');
      videoUrl = source?.src;
    }
    const videoUrlCleaned = videoUrl.split('/').pop().split('.').slice(0, -1).join('.');
    return videoUrlCleaned;
  }
  function adobeCartData() {
    return fetch(`${window.Shopify.routes.root}cart?section_id=adobe-track-cart`)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const cartData = JSON.parse(doc.getElementById('json').textContent);
        return cartData;
      })
      .catch(err => console.error(err));
  }
  function adobeProductData() {
    const productData = JSON.parse(document.getElementById('adobeAnalyticsProductData')?.textContent || null);
    if (productData) return productData;

    if (!SDG.Data.template.startsWith('product')) return null;

    return fetch(`${window.location.pathname}?section_id=adobe-track-product`)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const productData = JSON.parse(doc.getElementById('adobeAnalyticsProductData').textContent);
        return productData;
      })
      .catch(err => console.error(err));
  }

  // global page load
  const {
    page_name,
    page_type,
    page_url,
    page_title,
    language,
    country,
    currency,
    login_status,
    user_id
  } = SDG.Data.adobeAnalyticsData;
  Shopify.analytics.publish('APLdigitalDataEvent', {
    page_name,
    page_type,
    page_url,
    page_title,
    language,
    country,
    currency,
    login_status,
    ...(user_id && { user_id }),
  });

  // any page with product cards or product LOB modules
  if (document.querySelectorAll('.adobe-analytics-product-card-data, .adobe-analytics-lob-product-data').length) {
    const $cardsData = document.querySelectorAll('.adobe-analytics-product-card-data, .adobe-analytics-lob-product-data');

    let products = [];
    $cardsData.forEach(data => {
      const productData = JSON.parse(data.textContent);
      products.push(productData);
    });

    if (products.length) {
      Shopify.analytics.publish('APLdigitalDataEvent', {
        'event': 'product_list_impression',
        'product': products,
      });
    }
  }

  // header
  $(document).on('click', '.header__heading a, .header__icon.header__icon--account', function() {
    const target = this;
    const eventUrl = anchorHref(target);
    let eventText;

    if (target.classList.contains('header__icon--account')) {
      eventText = 'Profile User';
    } else {
      const appLogo = target.closest('.brand--logo');
      if (appLogo) {
        eventText = 'APP Logo';
      } else {
        eventText = 'Apple Logo';
      }
    }

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'header_click',
      'header_item': eventText,
      'click_url': eventUrl,
    });
  });

  // announcement bar
  $(document).on('click', '.hura-announcement-bar .announcement_link', function() {
    const target = this;
    const eventText = anchorText(target);
    const eventUrl = anchorHref(target);
    const parent = target.closest('.hura-message');
    const parentClone = parent.cloneNode(true);
    parentClone.querySelector('.announcement_link').remove();
    const parentText = elementText(parentClone);

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'ribbon_click',
      'ribbon_text': parentText,
      'click_text': eventText,
      'click_url': eventUrl,
    });
  });

  // header menu desktop
  $(document).on('click', '.header_nav .list-menu summary span, .header_nav #right_menu_items > li > a span', function() {
    const target = this;
    const parentSummary = target.closest('.header_nav .list-menu summary');
    const parentAnchor = target.closest('.header_nav #right_menu_items > li > a');

    const hasMenu = !!parentSummary;
    let eventText;
    if (hasMenu) {
      eventText= parentSummary.innerText;
    } else {
      eventText = parentAnchor.innerText;
    }

    const eventUrl = anchorHref(target, '#');
    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'menu_click',
      'menu_item': eventText,
      'click_url': eventUrl,
    });
  });

  // header menu mobile
  $(document).on('click', '#menu-drawer .list-menu summary, #menu-drawer .list-menu summary > svg:first-of-type, #menu-drawer #right_menu_mobile_items > li > a', function() {
    const target = this;
    const parentSummary = target.tagName === 'SUMMARY' ? target : target.closest('#menu-drawer .list-menu summary');
    const parentAnchor = target;

    const hasMenu = !!parentSummary;
    let eventText;
    if (hasMenu) {
      eventText = parentSummary.innerText;
    } else {
      eventText = parentAnchor.innerText;
    }

    const eventUrl = anchorHref(target, '#');

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'menu_click',
      'menu_item': eventText,
      'click_url': eventUrl,
    });
  });

  function setFormDigitalData($formName, $eventName) {
    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': `${$eventName}`,
      'form_name': `${$formName}`,
    });
  }

  // form start
  function formStart($target) {
    const eventType = 'form_start';
    let formType = $target.dataset.formType;

    /* If formType is not defined, find the closest form
    and get the data-form-type of the submit button/input */
    if (!formType) {
      const parent = $target.closest('form');
      const formSubmits = parent
        ? Array.from(parent.querySelectorAll('button, input[type="submit"]'))
        : [];

      if (!formSubmits.length) return false;

      formType = formSubmits.find((submit) => submit.dataset.formType)?.dataset.formType || '';
    }

    /* If form hasn't beed started yet, add it to the
    formStarted array and set the digital data */
    if (!formStarted?.includes(formType)) {
      formStarted.push(formType);
      setFormDigitalData(formType, eventType);
      return;
    }
  }

  // form submits
  function formSubmits($target) {
    const eventType = 'form_submit';
    let formType = $target.dataset.formType;

    if (!formType) {
      const parent = $target.closest('form');
      const formSubmits = parent
        ? Array.from(parent.querySelectorAll('button, input[type="submit"]'))
        : [];

      if (!formSubmits.length) return false;

      formType = formSubmits.find((submit) => submit.dataset.formType)?.dataset.formType || '';
    }
    formStarted = formStarted.filter((type) => type != formType);
    setFormDigitalData(formType, eventType);
  }

  // form start clicks
  $(document).on('input', 'form input', function(e) {
    const target = this;
    formStart(target);
  });

  // form submit clicks
  $(document).on('click', 'form input, form button', function() {
    const target = this;
    if (target.dataset?.formType) {
      formSubmits(target);
    }
  });

  // header submenu
  $(document).on('click', '.header_nav .header__submenu a.header__menu-item, #menu-drawer .menu-drawer__submenu .menu-drawer__menu-item', function() {
    const target = this;
    const eventText = anchorText(target);
    const eventUrl = anchorHref(target, '#');

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'sub_menu_click',
      'sub_menu_item': eventText,
      'click_url': eventUrl,
    });
  });

  // footer
  $(document).on('click', '.footer_content_list', function() {
    const target = this;
    const eventText = anchorText(target);
    const eventUrl = anchorHref(target);

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'footer_menu_click',
      'footer_menu_item': eventText,
      'click_url': eventUrl,
    });
  });

  // search text
  $(document).on('submit', '#nosubmit_form, #nosubmit_form2', function() {
    const target = this;
    const input = target.querySelector('input[name="q"]');
    const eventText = input.value;

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'search_button_click',
      'search_text': eventText,
    });
  });

  // search menu
  $(document).on('click', '.predictive-search a.predictive-search__item', function() {
    const target = this;
    const eventText = anchorText(target);
    const eventUrl = anchorHref(target);

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'search_menu_click',
      'search_term_suggestions': eventText,
      'click_url': eventUrl
    });
  });

  // search banner
  $(document).on('click', '#predictive-search-banner .predictive-search__banner', function() {
    const target = this;
    const eventUrl = anchorHref(target);
    const parent = target.closest('#predictive-search-results-products-list');
    const products = parent.querySelectorAll('.predictive-search__list-item--product .predictive-search__item-title');
    const productSuggestions = Array.from(products).map(elementText).join(', ');

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'search_banner_click',
      'search_product_suggestions': productSuggestions,
      'click_url': eventUrl
    });
  });

  // homepage LOB card
  $(document).on('click', 'div.lob_main_container div.lob_cards a', function() {
    const target = this;
    const eventText = target.closest('div.lob_main_container div.lob_cards a').querySelector('.lob_title').textContent;
    const eventUrl = anchorHref(target);
    const parent = target.closest('.lob_main_container');
    const parentTitle = elementText(parent.querySelector('.lob_heading'));

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'card_click',
      'card_name': eventText,
      'site_section': 'Family Stripe LOB',
      'slider_name': parentTitle,
      'click_url': eventUrl,
    });
  });

  // announcement bar slider arrow
  $(document).on('click', '.hura-announcement-bar .slick-arrow', function() {
    const target = this;
    let direction;
    if (target.classList.contains('slick-next')) {
      direction = 'Right'
    } else {
      direction = 'Left'
    }
    const parent = target.closest('.hura-announcement-bar');
    const parentTitle = elementText(parent.querySelector('.slick-current'));

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'slider_arrow_click',
      'slider_name': parentTitle,
      'slider_direction': direction,
    });
  });

  // homepage LOB slider arrow
  $(document).on('click', 'div.lob_main_container .slick-arrow', function() {
    const target = this;
    let direction;
    if (target.classList.contains('lobstripe-right-arrow')) {
      direction = 'Right'
    } else {
      direction = 'Left'
    }
    const parent = target.closest('.lob_main_container');
    const parentTitle = elementText(parent.querySelector('.lob_heading'));

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'slider_arrow_click',
      'slider_name': parentTitle,
      'slider_direction': direction,
    });
  });

  // homepage partner stripe card
  $(document).on('click', '.partner_pagewidth .partner_cards > a', function() {
    const target = this;
    const eventText = anchorText(target);
    const eventUrl = anchorHref(target);
    const parent = target.closest('.partner_main_container');
    const parentTitle = elementText(parent.querySelector('.partner_heading'));

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'card_click',
      'card_name': eventText,
      'site_section': 'Partner Stripe',
      'slider_name': parentTitle,
      'click_url': eventUrl,
    });
  });

  // homepage partner stripe slider arrow
  $(document).on('click', '.partner_pagewidth .slick-arrow', function() {
    const target = this;
    let direction;
    if (target.classList.contains('partner-right-arrow')) {
      direction = 'Right'
    } else {
      direction = 'Left'
    }
    const parent = target.closest('.partner_main_container');
    const parentTitle = elementText(parent.querySelector('.partner_heading'));

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'slider_arrow_click',
      'slider_name': parentTitle,
      'slider_direction': direction,
    });
  });

  // homepage APP stripe card
  $(document).on('click', '.app_pagewidth .app_cards > a', function() {
    const target = this;
    const eventText = anchorText(target);
    const eventUrl = anchorHref(target);
    const parent = target.closest('.app_main_container');
    const parentTitle = elementText(parent.querySelector('.app_heading'));

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'card_click',
      'card_name': eventText,
      'site_section': 'APP Stripe',
      'slider_name': parentTitle,
      'click_url': eventUrl,
    });
  });

  // homepage APP stripe slider arrow
  $(document).on('click', '.app_pagewidth .slick-arrow', function() {
    const target = this;
    let direction;
    if (target.classList.contains('appstripe-right-arrow')) {
      direction = 'Right'
    } else {
      direction = 'Left'
    }
    const parent = target.closest('.app_main_container');
    const parentTitle = elementText(parent.querySelector('.app_heading'));

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'slider_arrow_click',
      'slider_name': parentTitle,
      'slider_direction': direction,
    });
  });

  // global family stripe card
  $(document).on('click', '.apl_lob_slider .apl_lob_list_item > a', function() {
    const target = this;
    const eventText = anchorText(target);
    const eventUrl = anchorHref(target);

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'family_stripe_click',
      'card_name': eventText,
      'site_section': 'Family Stripe Navigation',
      'slider_name': '',
      'click_url': eventUrl,
    });
  });

  // collection slider product card click
  $(document).on('click', '.collection_slider .product-card a, .collection_slider .product-card a', function() {
    const target = this;
    const eventUrl = anchorHref(target);

    const parent = target.closest('.product-card, .product-item');
    const title = parent?.querySelector('.card-head');
    const eventText = title ? elementText(title) : '';

    const sliderParent = target.closest('.collection_slider, .conversion-module');
    const sliderParentTitle = elementText(sliderParent.querySelector('.collection_main_heading, .conversion-module__heading'));

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'product_list_section_click',
      'card_name': eventText,
      'site_section': 'Collection Slider',
      'slider_name': sliderParentTitle,
      'click_url': eventUrl,
    });
  });

  // product card slider arrow
  $(document).on('click', '.collection_slider .slick-arrow, .conversion-module .slick-arrow', function() {
    const target = this;
    let direction;
    if (target.classList.contains('next')) {
      direction = 'Right'
    } else {
      direction = 'Left'
    }
    const parent = target.closest('.collection_slider, .conversion-module');
    const parentTitle = elementText(parent.querySelector('.collection_main_heading, .conversion-module__heading'));

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'slider_arrow_click',
      'slider_name': parentTitle,
      'slider_direction': direction,
    });
  });

  // global family stripe slider arrow
  $(document).on('click', '#shopify-section-navigation_stripe .slick-arrow', function() {
    const target = this;
    let direction;
    if (target.classList.contains('nav-right-arrow')) {
      direction = 'Right'
    } else {
      direction = 'Left'
    }

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'family_stripe_arrow_click',
      'slider_name': 'Family Stripe Navigation',
      'slider_direction': direction,
    });
  });

  // product card slider pagination dot
  $(document).on('click', '.collection_slider .slick-dots li', function() {
    const target = this;

    const parent = target.closest('.collection_slider, .conversion-module');
    const parentTitle = elementText(parent.querySelector('.collection_main_heading, .conversion-module__heading'));
    const sliderPosition = parseInt(elementText(target)) - 1;

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'product_list_section_pagination_click',
      'slider_name': parentTitle,
      'slider_position': sliderPosition,
    });
  });

  // homepage slider banner image
  $(document).on('click', 'slideshow-component .full-link', function() {
    const target = this;
    const eventUrl = anchorHref(target);

    const parent = target.closest('slideshow-component .slideshow__slide');
    const slideInfo = parent?.getAttribute('aria-label');

    const sliderPosition = parseInt(slideInfo || 1) - 1;

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'banner_click',
      'site_section': 'Banner Section',
      'slider_name': 'Hero Banner Slider',
      'slider_position': sliderPosition,
      'click_url': eventUrl,
    });
  });

  // homepage slider banner click
  $(document).on('click', 'slideshow-component .slider-counter__link--dots', function() {
    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'banner_slider_click',
      'site_section': 'Banner Section'
    });
  });

  // ctas
  const ctaSelectors = [
    '.collage-button a',
    '.button_primary_anchor.card-btn',
    '.btn_prime_1.plp_page_ga a',
    '.image-with-text .img_with_txt_btn',
    '.multi_prop_tile_outer_new a',
  ]
  $(document).on('click', ctaSelectors.join(','), function() {
    const target = this;
    const eventText = anchorText(target);
    const eventUrl = anchorHref(target);

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'cta_click',
      'click_text': eventText,
      'click_url': eventUrl,
    });
  });
  const ctaButtonSelectors = [
    '.img_with_txt_outer [onclick*="location.href="]',
    '.image-with-text [onclick*="location.href="]',
  ]
  $(document).on('click', ctaButtonSelectors.join(','), function() {
    const target = this;
    const eventText = elementText(target);
    const onclickAttr = target.getAttribute('onclick');
    const regex = /location\.href\s*=\s*['"]([^'"]+)['"]/;
    const match = onclickAttr.match(regex);
    const eventUrl = match ? match[1] : '';

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'cta_click',
      'click_text': eventText,
      'click_url': eventUrl,
    });
  });

  // marketing pages
  $(document).on('click', '.ac-modal-trigger[data-ajax-url*="?view=river_content"]', function() {
    const target = this;
    const eventText = elementText(target);
    const pageUrl = target.dataset.ajaxUrl?.split('?view')?.[0]?.replace('/pages/', '') || '';

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'marketing_page_click',
      'marketing_page_name': pageUrl,
      'click_text': eventText,
    });
  });

  // marketing page cta clicks
  $(document).on('click', '.ac-modal .channel-html a[href]', function() {
    const target = this;
    const eventText = anchorText(target);
    const eventUrl = anchorHref(target);

    const parent = target.closest('.ac-modal');
    const modalTrigger = document.querySelector(`.ac-modal-trigger[data-modal-target="${parent.id}"]`);
    const pageUrl = modalTrigger.dataset.ajaxUrl?.split('?view')?.[0]?.replace('/pages/', '') || '';

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'marketing_page_cta_click',
      'marketing_page_name': pageUrl,
      'click_text': eventText,
      'click_url': eventUrl,
    });
  });
  window.adobeTrackMarketingPageIframeCtaClick = function(iframe) {
    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.querySelectorAll('a[href]').forEach(anchor => {
      anchor.addEventListener('click', function() {
        const target = this;
        const eventText = anchorText(target);
        const eventUrl = anchorHref(target);

        const parent = iframe.closest('.ac-modal');
        const modalTrigger = document.querySelector(`.ac-modal-trigger[data-modal-target="${parent.id}"]`);
        const pageUrl = modalTrigger.dataset.ajaxUrl?.split('?view')?.[0]?.replace('/pages/', '') || '';

        Shopify.analytics.publish('APLdigitalDataEvent', {
          'event': 'marketing_page_cta_click',
          'marketing_page_name': pageUrl,
          'click_text': eventText,
          'click_url': eventUrl,
        });
      });
    });
  }

  // marketing page scroll
  $(document).on('click', '.ac-modal-trigger[data-ajax-url*="?view=river_content"]:not([data-ajax-iframe="true"])', function() {
    const target = this;
    const pageUrl = target.dataset.ajaxUrl?.split('?view')?.[0]?.replace('/pages/', '') || '';
    const modal = document.querySelector(`#${target.dataset.modalTarget}`);
    if (!modal) return;

    const modalParent = modal.closest('.modal');
    if (modalParent?.classList?.contains('adobe-tracking-scroll')) return;

    modalParent.classList.add('adobe-tracking-scroll');

    const debouncedScroll = debounce(function() {
      const scrollDepth = Math.round((modalParent.scrollTop / (modalParent.scrollHeight - modalParent.clientHeight)) * 100);
      const steps = [100, 75, 50, 25, 0];
      const scrollThreshold = steps.find(step => scrollDepth >= step);

      window.APLdigitalDataClient = window.APLdigitalDataClient || [];
      if (scrollThreshold === 0
        || scrollThreshold === undefined
        || window.APLdigitalDataClient.find(data => data.event === 'marketing_page_scroll' && data.marketing_page_name === pageUrl && data.scroll_depth_threshold === `${scrollThreshold}%`)
      ) return;

      window.APLdigitalDataClient.push({
        'event': 'marketing_page_scroll',
        'marketing_page_name': pageUrl,
        'scroll_depth_threshold': `${scrollThreshold}%`,
      });

      Shopify.analytics.publish('APLdigitalDataEvent', {
        'event': 'marketing_page_scroll',
        'marketing_page_name': pageUrl,
        'scroll_depth_threshold': `${scrollThreshold}%`,
      });
    }, 50);
    $(modalParent).on('scroll', debouncedScroll);
  });
  window.adobeTrackMarketingPageIframeScroll = function(iframe) {
    const iframeDoc = iframe.contentWindow.document;
    const modalParent = iframe.closest('.modal');

    const parent = iframe.closest('.ac-modal');
    const modalTrigger = document.querySelector(`.ac-modal-trigger[data-modal-target="${parent.id}"]`);
    const pageUrl = modalTrigger.dataset.ajaxUrl?.split('?view')?.[0]?.replace('/pages/', '') || '';

    if (modalParent?.classList?.contains('adobe-tracking-scroll')) return;

    modalParent.classList.add('adobe-tracking-scroll');

    const debouncedScroll = debounce(function() {
      const scrollElement = iframeDoc.documentElement;
      const scrollDepth = Math.round((scrollElement.scrollTop / (scrollElement.scrollHeight - scrollElement.clientHeight)) * 100);
      const steps = [100, 75, 50, 25, 0];
      const scrollThreshold = steps.find(step => scrollDepth >= step);

      window.APLdigitalDataClient = window.APLdigitalDataClient || [];
      if (scrollThreshold === 0
        || window.APLdigitalDataClient.find(data => data.event === 'marketing_page_scroll' && data.marketing_page_name === pageUrl && data.scroll_depth_threshold === `${scrollThreshold}%`)
      ) return;

      window.APLdigitalDataClient.push({
        'event': 'marketing_page_scroll',
        'marketing_page_name': pageUrl,
        'scroll_depth_threshold': `${scrollThreshold}%`,
      });

      Shopify.analytics.publish('APLdigitalDataEvent', {
        'event': 'marketing_page_scroll',
        'marketing_page_name': pageUrl,
        'scroll_depth_threshold': `${scrollThreshold}%`,
      });
    }, 50);

    $(iframeDoc).on('scroll', debouncedScroll);
  }

  // non-marketing modal pages
  const modalTargets = [
    '="modal-net-monthly-pricing-modal"',
    '="modal-pdp-apple-care-modal"',
    '="modal-trade-in-modal"',
    '*="modal-cart-apple-care-modal"',
    '*="modal-cart-warranty-modal"',
    '*="modal-trade-in-learn-more-modal"',
    '*="modal-trade-in-modal"',
  ]
  $(document).on(
    'click',
    `
      ${modalTargets.map(target => `.ac-modal-trigger[data-modal-target${target}]`).join(',')},
      .js-trade-in-modal-trigger-secondary-cart
    `,
    function(e) {
      if (!e.originalEvent.isTrusted) {
        return;
      }

      const target = this;
      const eventText = elementText(target, true);

      const modalForTarget = document.querySelector(`.ac-modal[id=${target.dataset.modalTarget}]`);
      const modalTitleElem = modalForTarget?.querySelector('h1, h2, h3, h4, h5, h6, .apple-care-modal__heading');
      const modalTitle = modalTitleElem ? elementText(modalTitleElem, true) : '';

      Shopify.analytics.publish('APLdigitalDataEvent', {
        'event': 'modal_page_click',
        'modal_page_name': modalTitle,
        'click_text': eventText,
      });
    }
  );

  // non-marketing modal cta clicks
  $(document).on('click', modalTargets.map(target => `.ac-modal[id${target}] a[href], .ac-modal[id${target}] button`).join(','), function() {
    const target = this;
    let eventText;
    let eventUrl;

    if (target.tagName === 'A') {
      eventText = anchorText(target);
      eventUrl = anchorHref(target);
    } else {
      eventText = elementText(target);
      eventUrl = '';
    }

    const modalTitleElem = target.closest('.ac-modal').querySelector('h1, h2, h3, h4, h5, h6, .apple-care-modal__heading');
    const modalTitle = modalTitleElem ? elementText(modalTitleElem, true) : '';

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'modal_page_cta_click',
      'modal_page_name': modalTitle,
      'click_text': eventText,
      'click_url': eventUrl,
    });
  });

  // accordion
  $(document).on('click', '.product__accordion summary', function() {
    const target = this;
    const eventText = elementText(target);
    const action = target.getAttribute('aria-expanded') === 'true' ? 'accordion_open' : 'accordion_close';

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': action,
      'accordion_item': eventText,
    });
  });

  // external link click
  $(document).on('click', 'a[href^="http"]', function() {
    const target = this;
    const eventText = anchorText(target);
    const eventUrl = anchorHref(target);

    const urlHostname = (new URL(eventUrl))?.hostname;

    if (urlHostname === window.location.hostname) {
      return;
    }

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'external_link_click',
      'click_text': eventText,
      'click_url': eventUrl,
    });
  });

  // cart "More payment options" cta
  $(document).on('click', '.expedited-checkout .checkout-button__link', function() {
    const target = this;
    const eventText = elementText(target);

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'more_payment_options_click',
      'click_text': eventText,
    });
  });

  // view pdp
  if (SDG.Data.template.startsWith('product')) {
    async function prodView() {
      const productData = await adobeProductData();

      Shopify.analytics.publish('APLdigitalDataEvent', {
        'event': 'prodView',
        ...productData,
      });
    }
    prodView();
  }

  // pdp AppleCare
  $(document).on('click', '.product .add-on-product-style a[data-index]', async function() {
    const target = this;
    const isAppleCare = target.closest('.applecare-replace') ? true : false;
    const parent = target.closest('.product .add-on-product-style');

    const appleCareIsAdded = isAppleCare ? $('#add-apple-care').is(':checked') : $('#add-secWarranty').is(':checked');

    if (!appleCareIsAdded) return;
    const title = parent.querySelector('h3');

    const appleCarePlan = elementText(title);

    const productData = await adobeProductData();

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'applecare+_add',
      'apple_care+_plan': appleCarePlan,
      'product': productData?.product_name,
      'currency': productData?.currency,
      'product_price': productData?.product_price,
      'brand': productData?.brand,
    });
  });

  // cart AppleCare
  $(document).on('click', '.add-cart-apple-care[data-reference="aplcr"], .add-cart-apple-care[data-reference="secwr"]', function() {
    const target = this;
    const parent = target.closest('.cart_itemadd');

    const title = parent.querySelector('.apple-care-card-title');
    const appleCarePlan = elementText(title);

    const mainProductIndex = target.dataset.forproduct;
    const mainProductParent = document.getElementById(`CartItem-${mainProductIndex}`);
    const productData = JSON.parse(mainProductParent.querySelector('.adobe-analytics-cart-item-data').textContent).payload;

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'applecare+_add',
      'apple_care+_plan': appleCarePlan,
      'product': productData?.product_name,
      'currency': productData?.currency,
      'product_price': productData?.product_price,
      'brand': productData?.brand,
    });
  });

  // Store locator select store
  $(document).on('click', '.js-store-locator-select-btn', function() {
    const target = this;
    const parent = target.closest('my-store-locator-drawer');

    const activeResult = parent.querySelector(parent.dom.activeResult);
    const storeName = elementText(activeResult.querySelector('.my-location-result__name'));

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'pick-in_store_click',
      'store_name': storeName,
    });
  });

  // pdp quantity selector
  $(document).on('click', '.product-form__quantity .js-qty-input .quantity__button', async function() {
    const target = this;
    const productData = await adobeProductData();
    const event = target.name === 'plus' ? 'quantity_selector_plus' : 'quantity_selector_minus';

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': event,
      'product_name': productData?.product_name,
      'mpn_id': productData?.mpn_id,
    });
  });

  // cart quantity selector
  $(document).on('click', '.cart-item .quantity__button', function() {
    const target = this;
    const parent = target.closest('.cart-item');
    const productData = JSON.parse(parent.querySelector('.adobe-analytics-cart-item-data').textContent).payload;
    const event = target.name === 'plus' ? 'quantity_selector_plus' : 'quantity_selector_minus';

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': event,
      'product_name': productData?.product_name,
      'mpn_id': productData?.mpn_id,
    });
  });


  // pdp frequently bought together product
  $(document).on('change', '.js-frequent-products-checkbox', function() {
    const target = this;
    const isSelected = target.checked;
    const event = isSelected ? 'frequently_bought_together_product_select' : 'frequently_bought_together_product_unselect';

    const parent = target.closest('.frequent-product-list');
    const productData = JSON.parse(parent.querySelector('.adobe-analytics-frequently-products-card-data').textContent);

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': event,
      'product_name': productData?.title,
      'mpn_id': productData?.mpn,
    });
  });

  // video play
  $('video').on('play', function() {
    const target = this;
    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'video_play',
      'video_id': videoName(target),
    });
  });

  // video pause
  $('video').on('pause', function() {
    const target = this;
    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'video_pause',
      'video_id': videoName(target),
    });
  });

  // video progress
  $('video').on('timeupdate', function() {
    const target = this;
    const vidName = videoName(target);
    const duration = target.duration;
    const currentTime = target.currentTime;
    const progress = Math.round((currentTime / duration) * 100);
    const steps = [100, 75, 50, 25, 0];
    const progressThreshold = steps.find(step => progress >= step);

    window.APLdigitalDataClient = window.APLdigitalDataClient || [];
    if (progressThreshold === 100) {
      if (window.APLdigitalDataClient.find(data => data.event === 'video_complete' && data.video_id === vidName)) return;

      window.APLdigitalDataClient.push({
        'event': 'video_complete',
        'video_id': vidName,
      });

      Shopify.analytics.publish('APLdigitalDataEvent', {
        'event': 'video_complete',
        'video_id': vidName,
      });
    } else if (progressThreshold >= 0) {
      if (progressThreshold === 0
        || window.APLdigitalDataClient.find(data => data.event === 'video_progress' && data.video_id === vidName && data.video_progress === `${progressThreshold}%`)
      ) return;

      window.APLdigitalDataClient.push({
        'event': 'video_progress',
        'video_id': vidName,
        'video_progress': `${progressThreshold}%`,
      });

      Shopify.analytics.publish('APLdigitalDataEvent', {
        'event': 'video_progress',
        'video_id': vidName,
        'video_progress': `${progressThreshold}%`,
      });
    }
  });

  // account login
  $(document).on('submit', '#customer_login', function() {
    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'login',
      'login_form_location': 'login page',
    });
  });

  // account logout
  $(document).on('click', 'a[href*="/account/logout"]', function() {
    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'logout',
      'login_form_location': 'login page',
    });
  });

  // account register form start
  $(document).on('input', '#create_customer', function() {
    window.APLdigitalDataClient = window.APLdigitalDataClient || [];

    if (!window.APLdigitalDataClient.some(data => data.event === 'signup_start')) {
      window.APLdigitalDataClient.push({
        'event' : 'signup_start',
      });

      Shopify.analytics.publish('APLdigitalDataEvent', {
        'event' : 'signup_start',
      });
    }
  });

  // account register form submit
  $(document).on('submit', '#create_customer', function() {
    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event' : 'signup_success',
    });
  });

  // filters click
  $(document).on('click', '#FacetFiltersForm .facet-checkbox input', function() {
    const target = this;

    const parent = target.closest('.js-filter');
    const parentItem = target.closest('.facets__item');
    if (!parent) return '';

    const category = parent.querySelector('.facets__summary');
    const cloneCategory = category.cloneNode(true);
    cloneCategory.querySelector('.facets__selected')?.remove();
    const categoryText = category ? elementText(cloneCategory) : '';

    let labelText;

    if (parentItem.classList.contains('list-menu__item--pickup')) {
      const label = parentItem ? parentItem.querySelector('span') : null;
      const pickupText = label ? elementText(label) : '';
      const location = parentItem ? parentItem.querySelector('.js-my-store-locator-search-drawer-launcher') : null;
      const locationText = location ? elementText(location) : '';
      labelText = `${pickupText} ${locationText}`;
    } else {
      const label = parentItem ? parentItem.querySelector('span[aria-hidden]') : null;
      const cloneLabel = label?.cloneNode(true);
      cloneLabel?.querySelector('.filter-count')?.remove();
      labelText = label ? elementText(cloneLabel) : '';
    }

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'filter_click',
      'filter_category': categoryText,
      'filter_item': labelText,
    });
  });

  // sort change
  $(document).on('input', '#FacetSortForm', function() {
    const target = this;
    const sortSelect = target.querySelector('#SortBy');
    const activeSortOption = sortSelect.querySelector('option:checked');
    const activeSortLabel = elementText(activeSortOption);

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'sort_click',
      'sort_type': activeSortLabel,
    });
  });

  // add to cart
  window.adobeTrackAddToCart = async function(opts = {
    items: {
      id, // variant id of item being added
      quantity, // quantity of item being added
    },
    context, // context of the add to cart action
    $trigger, // element that triggered the add to cart action
    triggerText, // overrides the trigger text if a trigger element is not provided
    triggerUrl, // url that the trigger redirects to if applicable
  }) {
    const { items, context, $trigger, triggerText, triggerUrl } = opts;

    const trackCartData = await adobeCartData();
    const trackingProducts = [];
    items.forEach(item => {
      const productData = trackCartData.items.find(cartItem => cartItem.variant_id === parseInt(item.id));
      if (!productData) return;

      trackingProducts.push({
        units: item.quantity,
        ...productData.payload
      });
    });

    let clickText;
    if (triggerText) {
      clickText = triggerText;
    } else {
      clickText = elementText($trigger);
    }

    const finalObj = {
      'event': 'scAdd',
      'product': trackingProducts,
      'click_text': clickText,
      'click_url': triggerUrl || '',
      'add_to_cart_context': context,
    }

    Shopify.analytics.publish('APLdigitalDataEvent', finalObj);

    // add to cart - first product(s) added to cart
    const adobeTrackedFirstAdd = trackCartData.items.every(cartItem => {
      return items.some(item => parseInt(item.id) === parseInt(cartItem.variant_id) && parseInt(item.quantity) === parseInt(cartItem.quantity));
    });

    if (adobeTrackedFirstAdd) {
      Shopify.analytics.publish('APLdigitalDataEvent', {
        'event': 'scOpen',
        'product': trackingProducts,
        'add_to_cart_context': context,
      });
    }
  }

  // view cart
  window.adobeTrackViewCart = async function() {
    const trackCartData = await adobeCartData();

    const trackingProducts = trackCartData.items.map(item => {
      return {
        units: item.quantity,
        ...item.payload
      };
    });

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event': 'scView',
      'product': trackingProducts,
    });
  }
  if (SDG.Data.template === 'cart') {
    window.adobeTrackViewCart();
  }

  // remove from cart
  $(document).on('click', '.cart-item cart-remove-button', function() {
    const target = this;
    const parent = target.closest('.cart-item');
    const productData = JSON.parse(parent.querySelector('.adobe-analytics-cart-item-data').textContent);

    const trackingProducts = [{
      units: productData.quantity,
      ...productData.payload
    }];

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event' : 'scRemove',
      'product': trackingProducts,
    });

    const mainProductIndex = parent.id.split('-')[1];
    const appleCareRemoves = document.querySelectorAll(`cart-remove-button[data-mnprdctidx="${mainProductIndex}"] .applecareremove-a`);

    appleCareRemoves.forEach(appleCareRemove => {
      trackRemoveAppleCare(appleCareRemove);
    });
  });

  // remove AppleCare from cart
  trackRemoveAppleCare = function(target) {
    const parent = target.closest('.apple-care-show-mobile, .apple-care-show-desktop');

    const title = parent.querySelector('.apple-care-card-title');
    const appleCarePlan = elementText(title);

    const mainProductIndex = target.closest('cart-remove-button').dataset.mnprdctidx;
    const mainProductParent = document.getElementById(`CartItem-${mainProductIndex}`);
    const productData = JSON.parse(mainProductParent.querySelector('.adobe-analytics-cart-item-data').textContent);

    const trackingProducts = [{
      units: productData.quantity,
      ...productData.payload
    }];

    Shopify.analytics.publish('APLdigitalDataEvent', {
      'event' : 'scRemove',
      'apple_care+_plan': appleCarePlan,
      'product': trackingProducts,
    });
  }
  $(document).on('click', 'cart-remove-button .applecareremove-a', function() {
    const target = this;
    trackRemoveAppleCare(target);
  });

  // collection slider product list section impression
  function productListImpressions() {
    const observerOptions = {
      threshold: 0.9,
    };

    let products = [];

    const debouncedPushData = debounce(function() {
      if (!products.length) return;

      Shopify.analytics.publish('APLdigitalDataEvent', {
        'event': 'product_list_section_impression',
        'product': products,
      });

      products = [];
    }, 10);

    function observerCallback(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const slickParent = entry.target;
          const numSlides = $(slickParent).slick('getSlick').slideCount;
          const $cards = slickParent.querySelectorAll('.product-card, .item-card');
          const $activeCards = slickParent.querySelectorAll('.product-card.slick-active, .item-card.slick-active');
          const activeCardIndices = Array.from($activeCards).map(card => Array.from($cards).indexOf(card) % numSlides);
          slickParent.dataset.activeCardIndices = activeCardIndices.join(',');

          $activeCards.forEach($card => {
            const productData = JSON.parse($card.querySelector('.adobe-analytics-product-card-data').textContent);
            products.push(productData);
          });

          debouncedPushData();
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    const $productLists = document.querySelectorAll('.collection_slider .slick-initialized:not(.is-observed), .conversion-module .slick-initialized:not(.is-observed)');
    $productLists.forEach($productList => {
      observer.observe($productList);
      $productList.classList.add('is-observed');

      const slickParent = $productList;
      if (slickParent) {
        $(slickParent).on('afterChange', function() {
          const numSlides  = $(slickParent).slick('getSlick').slideCount;
          const $cards = slickParent.querySelectorAll('.product-card, .item-card');
          const $activeCards = slickParent.querySelectorAll('.product-card.slick-active, .item-card.slick-active');

          const previousActiveCardIndices = slickParent.dataset.activeCardIndices?.split(',').map(index => parseInt(index));
          if (!previousActiveCardIndices) return;
          const activeCardIndices = Array.from($activeCards).map(card => Array.from($cards).indexOf(card) % numSlides);
          const newActiveCardIndices = activeCardIndices.filter(index => !previousActiveCardIndices.includes(index));

          const $newActiveCards = Array.from($cards).filter((card, index) => newActiveCardIndices.includes(index));
          slickParent.dataset.activeCardIndices = activeCardIndices.join(',');

          $newActiveCards.forEach($card => {
            const productData = JSON.parse($card.querySelector('.adobe-analytics-product-card-data').textContent);
            products.push(productData);
          });

          debouncedPushData();
        });
      }
    });
  }
  productListImpressions();
  window.adobeTrackProductListImpressions = productListImpressions;
});
